import { call, put, takeLatest, take } from 'redux-saga/effects';
import { NotificationType, SignalRNotificationType } from '../../types';
import notificationsApi from '../../api/notificationsApi';
import { notificationActions, NotificationActions } from '../creators';
import { eventChannel } from 'redux-saga';
import { HubConnectionBuilder } from '@aspnet/signalr';

function* handleGetNotifications() {
  const { request, success, failure } = notificationActions.getNotificationsRequest;
  yield request();
  try {
    const payload: NotificationType[] = yield call(notificationsApi.getNotifications);
    yield put(success(payload));
  } catch (error) {
    yield put(failure(error.response));
  }
}

function* handleMarkNotificationAsRead(action: ReturnType<typeof notificationActions.markNotificationAsRead>) {
  const { request, success, failure } = notificationActions.markNotificationAsReadRequest;
  yield request();
  try {
    const payload: NotificationType = yield call(notificationsApi.markNotificationAsRead, action.payload);
    yield put(success(payload));
  } catch (error) {
    yield put(failure(error.response));
  }
}

function* handleMarkAllNotificationsAsRead() {
  const { request, success, failure } = notificationActions.markAllNotificationsAsReadRequest;
  yield request();
  try {
    yield call(notificationsApi.markAllNotificationAsRead);
    yield put(success());
    yield call(handleGetNotifications);
  } catch (error) {
    yield put(failure(error.response));
  }
}

function initializeWebSocket(url: string) {
  return eventChannel((emitter: (action: NotificationActions) => void) => {
    const connection = new HubConnectionBuilder().withUrl(url).build();

    connection
      .start()
      // eslint-disable-next-line no-console
      .then(() => console.info('WS started'))
      // eslint-disable-next-line no-console
      .catch((error: Error) => console.error('WS error: ', error));

    // eslint-disable-next-line no-console
    connection.onclose((error?: Error) => console.error('WS closed: ', error));

    connection.on('notify', (data: SignalRNotificationType) => {
      return emitter(notificationActions.addNotification(data));
    });

    return () => {
      connection.stop();
    };
  });
}

function* webSocketSaga() {
  if (typeof window !== 'undefined' && process.env.REACT_APP_HUB_ROOT) {
    const channel = yield call(initializeWebSocket, process.env.REACT_APP_HUB_ROOT);
    while (true) {
      const action = yield take(channel);
      yield put(action);
    }
  }
}

export default function* notificationsSaga() {
  yield takeLatest([notificationActions.getNotifications], handleGetNotifications);
  yield takeLatest([notificationActions.markNotificationAsRead], handleMarkNotificationAsRead);
  yield takeLatest([notificationActions.markAllNotificationsAsRead], handleMarkAllNotificationsAsRead);
  yield takeLatest([notificationActions.getNotifications], webSocketSaga);
}
